const media = [
        {
        id: "tdlc",
        title: "The Dark Lord's Confession",
        author: "topseung",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/tdlc.webp',
        type: ["Webcomic", "Comics", "Featured"],
        quote: "This curse left by the dark lord... I'll break free from it no matter what!!",
        short_desc: "",
        long_desc: [
        "After months of trying and failing to cast magic, Lapis finally manages to cast a spell - a 'Lovey-dovey Summoning Sigil', which summons the dark lord who's been sealed away for 1000 years. Who is a girl btw"],

        translated: false,

        links: [
            {
                key: "1",
                title: "Webtoon",
                source: "https://www.webtoons.com/en/fantasy/the-dark-lords-confession/list?title_no=4464",
            },
           
        ],

        tags: ["Webtoon", "Fantasy", "LGBT+"],
        featured: true,

        gallery: [
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/tdlc/2.jpg',
        },
                {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/tdlc/3.jpg',
        },
                        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/tdlc/4.jpg',
        },
    ]

    },
    {
        id: "no6",
        title: "No. 6",
        author: "Atsuko Amano",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/no6_cover.jpg',
        type: ["Literature","Light Novel", "Featured"],
        short_desc: "",
        long_desc: [`Shion has been raised as a high-ranking elite since the age of two, but on the night of his twelfth birthday, his fate is turned upside-down when he meets a boy who calls himself Nezumi.`],

        quote: "I couldn't avoid it. I, out of all people, let myself get caught.",
        translated: true,
        translator: "Nostalgia on 9th Avenue",

        links: [
            {
                key: "1",
                title: "Blogspot",
                source: "https://9th-ave.blogspot.com/p/no-6.html",
            },
            {
                key: "2",
                title: "Google Drive (EPUB, MOBI, PDF)",
                source: "https://drive.google.com/drive/folders/0B27FbCU2Ky6qNDU3OTU3OTYtMWFlYi00YjEyLWFiMDUtMTcxYjE5NzMwMTg5?resourcekey=0-sAlosxl-6Xp_6TgLiB1qBg&usp=sharing",
            },
            {
                key: "3",
                title: "EPUB Mirror (Download)",
                source: process.env.PUBLIC_URL+ './files/media/EPUB-No6.zip',

            }
        ],

        tags: ["Light Novel", "Literature", "BL", "Sci-Fi"],
        featured: true,

        gallery: [
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/no6/1.jpg',
        },
                {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/no6/2.jpg',
        },
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/no6/3.png',
        },
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/no6/4.png',
        },
    ]

    },
    {
        id: "no6reunion",
        title: "No. 6 Reunion",
        author: "Atsuko Amano",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/no6_reunion.webp',
        type: ["Literature"],
        short_desc: "The sequel to No. 6",
        long_desc: [`"Reunion will come."`, "After 14 years, the sequel to No.6 is finally out!", "The fan translator recieved a cease and desist even though there's no official translation for No. 6 or No. 6 Reunion. So, Book #1 is the only one they were able to translate, and it's kind of contraband."],

        links: [
            {
                key: "1",
                title: "Book #1 - Download (EPUB)",
                source: process.env.PUBLIC_URL+ './files/media/No6ReunionVol1.epub',
            },
            {
                key: "2",
                title: "Book #1 - Wayback Machine",
                source: "https://web.archive.org/web/20250703183647/https://no6reunion.wordpress.com/"
            },
            {
                key: "3",
                title: "Book #1 - Anna's Archive (PDF)",
                source: "https://en.wikipedia.org/wiki/Anna%27s_Archive"
            },
            {
                key: "4",
                title: "[ENG] Summaries of books 2-4",
                source: "https://aowyn.tumblr.com/post/815158188711280640/els-no6-resources-masterpost-updated-28-april"
            }
            
        ],

        tags: ["Light Novel", "Literature", "BL", "Sci-Fi"],
        featured: true,
        gallery: [
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/reunion/2.webp',
        },
                {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/reunion/3.webp',
        },
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/reunion/4.webp',
        },
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/reunion/5.webp',
        },
    ]

    },
     {
        id: "jwqs",
        title: "Clear and Muddy Loss of Love",
        alternate_titles: ["Two Adamant Hearts", "泾渭情殇 (JWQS)"],
        author: "请君莫笑 Please Don’t Laugh",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/jwqs.png',
        type: ["Literature", "Featured"],
        quote: 'Your Highness, before I kill you with my own hands, I will treat you with sincerity too.',
        short_desc: "",
        long_desc: ['Qiyan Agula, a prince of the grass plains, has a singular goal in life: to get revenge on the king of the neighboring Wei kingdom, who exterminated her tribe.',
            "The plan is complicated somewhat when she marries the king's daughter."
        ],

        translated: true,
        translator: "Meltsmelts @ Twitter",

        links: [
            {
                key: "1",
                title: "Carrd",
                source: "https://jwqs.carrd.co/ ",
            },
            {
                key: "2",
                title: "Google Drive (Docs)",
                source: "https://drive.google.com/drive/folders/1GVVb2LGSfKmv7fZh9whXbCIXXohaBCnj",
            }
        ],

        tags: ["GL", "Historical", "Baihe", "Political Intrigue"],
        featured: true,

        gallery: [
            {
            type: 'video',
            src: process.env.PUBLIC_URL+ '/images/media-library/jwqs/aAaMbGdemqv17uPg.mp4',
        },
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/jwqs/1.webp',
        },
                {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/jwqs/2.jpg',
        },
        {
            type: 'img',
            src: process.env.PUBLIC_URL+ '/images/media-library/jwqs/3.jpg',
        }]

    },
    {
        id: "tgcf",
        title: "Heaven Official's Blessing",
        alternate_titles: ["Tian Guan Ci Fu"],
        author: "Mo Xiang Tong Xiu",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/tgcf_hardcover.webp',

        translated: true,
        translator: "Suika",


        type: ["Literature", "Audiobook"],
        quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: ['Xie Lian has been kicked out of heaven twice. After ascending to heaven a third time, at the ripe old age of 800 years old, he decides to build his own shrine and live a peaceful existence.',
            "Unfortunateley, Xie Lian is not a a man who is capable of minding his own business. As he uncovers corruption in the heavenly court, he finds that much of it is linked to the horrors of his past.",
            "Luckily, he has a friend by his side. A mischievous, sharp-witted, and very definitely alive young man. Well, maybe he's not alive. Actually, he's probably the king of ghosts who murdered 33 heavenly officials, but Xie Lian has a job so he doesn't really care about that right now."
        ],

        links: [
            {
                key: "1",
                title: "[ENG] Audiobooks (Books 1-5)",
                source: "https://www.youtube.com/@CrimsonRainAudiobook/playlists ",
            }, 
            {
                key: "2",
                title: "[ENG] Audio Drama",
                source: "https://alliumms.tumblr.com/post/764438703341993984/im-translating-the-entire-tgcf-audio-drama?is_liked_post=1"
            }
        ],

        tags: ["BL", "Fantasy", "Historical", "Mystery", "Danmei"],
        featured: false

    },
     {
        id: "tyov",
        title: "Thousand Year Old Vampire",
        author: "Tim Hutchings",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/tyov.png',
        type: ["Games", "Solo", "Multiplayer", "TTRPG", "Journaling"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: ["At the time of addition to this library, there are 965418 community copies for Thousand Year-old Vampire, and you can claim one for free.",
            "A creaking hunter among dust and cobwebs, you prowl the night places, seeking the souls on which you feed. You have done this since time immemorial, or so you believe; you have no memories of  living as a man-thing like those you catch and eat. But human traces linger; your fingers trace clever arabesques in the dirt of your grave-place and with the flourishes come whispered songs in a language you've forgotten. Far away, in a museum, hangs your portrait in oil by a master five hundred years dead--you might have been lovers but the diary you kept then is long lost."
        ],

        links: [
            {
                key: "1",
                title: "itch.io",
                source: "https://timhutchings.itch.io/tyov",
            }
        ],

        tags: ["Solo", "Multiplayer", "TTRPG", "Journaling"],
        featured: false

    },
         {
        id: "dp",
        title: "Dead Plate",
        author: "Studio Investigrave",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/dead_plate.png',
        type: ["Games", "Solo", "Video Game", "Application"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: ["Dead Plate is a short 2D restaurant tycoon themed rpg horror game with visual novel and point-and-click elements set in 1960s France. It follows the story of a lively waiter named Rody trying to make as much money as possible in a week at a fancy bistro owned by a charismatic and successful chef, Vince.",
        ],

        links: [
            {
                key: "1",
                title: "itch.io",
                source: "https://racheldrawsthis.itch.io/dead-plate",
            }
        ],

        tags: ["Solo", "Video Game", "Application", "Horror", "Papa's Pizzaria-like"],
        featured: false

    },
    {
        id: "mrtr",
        title: "Mausritter",
        author: "Losing Games",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/mausritter.webp',
        type: ["Games", "Multiplayer", "TTRPG"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: ["Take up the sword and don the whiskers of a brave mouse adventurer in Mausritter, a rules-light fantasy adventure roleplaying game.",
        ],

        links: [
            {
                key: "1",
                title: "itch.io",
                source: "https://losing-games.itch.io/mausritter",
            }
        ],

        tags: ["Multiplayer", "TTRPG", "Fantasy", "DnD-like"],
        featured: false

    },
     {
        id: "adwd",
        title: "A Date With Death",
        author: "Two and a Half Studios",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/adwd.jpg',
        type: ["Games", "Solo", "Video Game"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: ["Base game is free but the DLC expansion is paid. The base game is a complete game!",
            "You're just an ordinary person... or so you thought. For your entire life, you've been narrowly avoiding death by pure luck... or is it something more? When a strange program suddenly appears on your computer, and someone claiming to be the Grim Reaper says he's come for your soul, your life as you know it is thrown upside down."
        ],

        links: [
            {
                key: "1",
                title: "itch.io",
                source: "https://losing-games.itch.io/mausritter",
            },
            {
                key: "1",
                title: "Steam",
                source: "https://store.steampowered.com/app/2415010/A_Date_with_Death/",
            }
        ],

        tags: ["Solo", "Video Game", "Dating Sim", "Chatsim", "Visual Novel"],
        featured: false

    },
    {
        id: "honey heist",
        title: "Honey Heist",
        author: "gshowitt",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/honey.png',
        type: ["Games", "Multiplayer", "TTRPG"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: ["Honey Heist is a surprisingly successful one-page RPG. Here is the plot:",
            "1) You have a complex plan that requires precise timing.",
            "2) You are a GODDAMN BEAR.",
            "That's largely it. It's easy to run and easy to play, and there's a D8 table for hats if you want to be a bear that wears a hat, and who doesn't want that?"
        ],

        links: [
            {
                key: "1",
                title: "itch.io",
                source: "https://gshowitt.itch.io/honey-heist",
            },
        ],

        tags: ["Multiplayer", "TTRPG", "Goofy", "You are a GODDAMN BEAR !"],
        featured: false

    },
     {
        id: "villainess",
        title: "Reincarnated as the Unlovable Villainess?!",
        author: "wym_lawson",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/unlovable.png',
        type: ["Games", "Solo", "TTRPG", "Journaling"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: [
            "You are reincarnated into a fantasy otome game you love. Unfortunately, you are not the beautiful and lovely Protagonist Penelope. Rather, you her romantic rival, the arrogant, petty, and unlovable villainess who is rude to Penelope whenever, wherever. What’s worse is that you are doomed to be killed or imprisoned in every single route. How can you avoid all the bad endings?",
            "Reincarnated as the Unlovable Villainess?! is a solo journaling game. To play this game, you will need at least 1d6, 1d20, and a method of recording your game."
        ],

        links: [
            {
                key: "1",
                title: "itch.io",
                source: "https://wym-lawson.itch.io/reincarnated-as-the-unlovable-villainess",
            },
        ],

        tags: ["Solo", "TTRPG", "Journaling", "Fantasy"],
        featured: false

    },
    {
        id: "cookie",
        title: "Cookie Clicker",
        author: "Orteil",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/cookie.jpg',
        type: ["Games", "Solo", "Video Game"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: [
            "Free version on web is a full game. There is a paid version on steam with a few more goodies.",
            "Click cookies. Click cookies. Click cookies. Click cookies. Click cookies."
        ],

        links: [
            {
                key: "1",
                title: "Website",
                source: "https://cookieclicker.com/",
            },
        ],

        tags: ["Solo", "Video Game", "Idle", "Clicker", "Goofy"],
        featured: false

    },
    {
        id: "wadanohara",
        title: "Wadanohara and the Great Blue Sea",
        author: "Deep-sea Prisoner",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/wadanohara_banner.webp',
        type: ["Games", "Solo", "Video Game"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: [
            "A clear blue sea under a beautiful blue sky.",
            "After a long departure, the sea witch Wadanohara travels back home with her familiars.",
            "But her ex-familiar, the shark Samekichi, appears to block her way:",
            "You shouldn't be here... Leave this sea, right now."
        ],

        links: [
            {
                key: "1",
                title: "(JP) 2022 Official Reboot - itch.io",
                source: "https://funamusea.itch.io/wadanohara",
            },
            {
                key: "2",
                title: "(EN) Fan Translator's Website ",
                source: "https://vgperson.com/games/wadanohara.htm",
            },
        ],

        tags: ["Solo", "Video Game", "RPG Maker"],
        featured: false,
        
        gallery: [
            {
                type: 'img',
                src: process.env.PUBLIC_URL+ '/images/media-library/wadanohara/1.png',
            },
            {
                type: 'img',
                src: process.env.PUBLIC_URL+ '/images/media-library/wadanohara/2.png',
            },
            {
                type: 'img',
                src: process.env.PUBLIC_URL+ '/images/media-library/wadanohara/3.png',
            },
            {
                type: 'img',
                src: process.env.PUBLIC_URL+ '/images/media-library/wadanohara/4.png',
            }
        ]

    },
    {
        id: "tma",
        title: "The Magnus Archives",
        author: "Rusty Quill",
        thumbnail: process.env.PUBLIC_URL+ '/images/media-library/tma.png',
        type: ["Audio", "Podcast"],
        // quote: "Only after having met you did I discover that it’s such a simple thing to be happy.",
        short_desc: "",
        long_desc: [
            "The Magnus Archives is a weekly horror fiction anthology podcast examining what lurks in the archives of the Magnus Institute, an organisation dedicated to researching the esoteric and the weird. Join new head archivist Jonathan Sims as he attempts to bring a seemingly neglected collection of supernatural statements up to date, converting them to audio and supplementing them with follow-up work from his small but dedicated team."
        ],

        links: [
            {
                key: "1",
                title: "Rusty Quill Website",
                source: "https://rustyquill.com/show/the-magnus-archives/",
            },
           
        ],

        tags: ["Podcast", "Horror"],
        featured: false

    },
      
];
export default media;